import React from 'react';
import { Paper } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import { shouldShowScheduledDeployment } from 'Selectors';
import Layout from 'Components/Layout';
import useDeploymentHistory from 'Hooks/query-hooks/revisions/useDeploymentHistory';
import useDeploySummary from 'Hooks/query-hooks/deployment/useDeploySummary';
import useGetReduxUsers from 'Hooks/reduxHelperHooks/useGetReduxUsers';
import errorController from 'Components/ErrorScreens';
import PageHeader from 'Components/PageHeader';
import RouteLoading from 'Components/RouteLoading';
import DeploymentHistoryTable from './components/DeploymentHistoryTable';
import CurrentDeploymentTable from './components/CurrentDeploymentTable';
import RevisionsScheduledDeploymentTable from './components/RevisionsScheduledDeploymentTable';

import styles from './Revisions.css';

const Revisions: React.FC = () => {
    const { t } = useTranslation();
    const { users } = useGetReduxUsers();
    const deploymentHistory = useDeploymentHistory(users, shouldShowScheduledDeployment());
    const deploymentSummary = useDeploySummary(shouldShowScheduledDeployment());
    const { hasError, errorCmp } = errorController([deploymentSummary.isError]);

    if (hasError) return <>{errorCmp}</>;
    if (deploymentHistory.isLoading || deploymentSummary.isLoading) {
        return <RouteLoading />;
    }

    // if no deployment, then deploymentData = []
    // if there's a deployment,  return a single deployment object
    const latestDeployment = deploymentHistory.data?.shift();

    return (
        <Layout>
            <PageHeader>
                <PageHeader.Left data-testid='mainPageHeader' className={styles.headerText}>
                    {t('Revisions')}
                </PageHeader.Left>
            </PageHeader>
            <div className={styles.tableContainer}>
                <CurrentDeploymentTable
                    latestDeploymentHistory={latestDeployment}
                    deploymentSummary={deploymentSummary.data!}
                />
                {shouldShowScheduledDeployment() && <RevisionsScheduledDeploymentTable />}
                <Paper>
                    <DeploymentHistoryTable
                        isLoading={deploymentHistory.isLoading}
                        deploymentHistory={deploymentHistory.data}
                    />
                </Paper>
            </div>
        </Layout>
    );
};

export default Revisions;
